import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSearchParamsUpdater } from 'hooks/useSearchParamsUpdater';
import { useSyncedDate } from 'hooks/useSyncedDate';
import { mapToOptions } from 'helpers/mapToOptions';
import { scrollDate } from 'helpers/scrollDate';
import { DatePicker } from 'components/DatePicker';
import { Dropdown } from 'components/Dropdown';
import { Button } from 'components/Button';
import { ChooseLocation } from './ChooseLocation';
import styles from 'pages/Schedule/Header/Header.scss';

export const Header = ({ isCreateModalOpen, setIsCreateModalOpen }) => {
  const { locations } = useSelector((state) => state.locations);
  const query = useSearchParamsUpdater();
  const { locationName } = useParams();

  const locationTransliteration = query.getParam('location') || locationName;
  const location = useMemo(() => locations.find(({ transliteration }) => transliteration === locationTransliteration));

  const [currentDate, setCurrentDate] = useSyncedDate(!!locationTransliteration);
  const handleDateChange = useCallback(
    (direction) => setCurrentDate((prev) => scrollDate(prev, direction)),
    [setCurrentDate]
  );

  const hallsOptions = useMemo(() => (location?.halls ? mapToOptions(location.halls) : []), [location]);
  const hallID = Number(query.getParam('hall'));
  const selectedHall = useMemo(
    () => hallsOptions.find(({ value }) => value === hallID) || null,
    [hallID, hallsOptions]
  );
  const handleHallChange = useCallback(
    (option) => {
      const value = option?.value;
      if (value) {
        query.setParam('hall', value);
      } else {
        query.deleteParam('hall');
      }
    },
    [query]
  );

  return (
    <div className={styles.header}>
      <div>
        <div className={styles.titleWrapper}>
          <h1>
            <FontAwesomeIcon icon={faCalendarAlt} /> Записи
          </h1>
        </div>
        <ChooseLocation />
        {location?.halls.length > 1 && (
          <Dropdown
            className={styles.dropdown}
            options={hallsOptions}
            value={selectedHall}
            onChange={handleHallChange}
            placeholder='Оберіть залу'
          />
        )}
      </div>
      <DatePicker
        className={styles.datePicker}
        date={currentDate}
        handleScrollDate={handleDateChange}
        showDay
        enableCalendar
      />
      <Button
        className={styles.addBtn}
        text='Додати запис'
        onClick={() => setIsCreateModalOpen(true)}
        disabled={isCreateModalOpen}
        smallStyle
      />
    </div>
  );
};
